import './JobExperianceComp.css';
let JobExperianceComp=(props)=> {

    

    return(
        <li className='loop_li_of_exp'>
            <span>{props.ExperienceData.ExperianceYear} </span>
             {props.ExperienceData.Year} 
             <span> {props.ExperienceData.CompanyName} </span> 
             {props.ExperienceData.At} 
             <span> {props.ExperienceData.CompanyAddress} </span> 
             {props.ExperienceData.From} 
             <span> {props.ExperienceData.FromDateToDate } </span>
        </li>
    );
}
export default JobExperianceComp;